/**
 * Up to two uppercased leading letters of a name — e.g. `"Marit Aas"` → `"MA"`,
 * `"Du"` → `"DU"`. The single home for the avatar/medallion initials that were
 * previously re-implemented across the apps.
 */
export function initials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
